
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import {
  Transaction,
  SystemProgram,
  Connection,
  PublicKey,
  LAMPORTS_PER_SOL
} from '@solana/web3.js';
import { Input } from '../../../components/ui/input';
import { toast } from 'sonner';
import { Button } from "../../../components/ui/button";

import { useConnection } from "@solana/wallet-adapter-react";
import { convertTime } from '../../utils/convertTime';

import { FaTelegram } from "react-icons/fa6";
import { FaDiscord } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import WhitelistPaymentSelector from './WhitelistPaymentSelector';
import { useMakePayment } from '../../hooks/payments/useMakePayment';
import { useSolPrice } from '../../hooks/useSolPrice';
import { FaCheckCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { socials } from '../../links';


const WhiteListsPayment = ({ solPrice, user, loading, connected }) => {

  // const [user, setUser] = useState(false)
  // const [transaction, setTransaction] = useState(false)
  // const [loading, setLoading] = useState(true)
  const { vault, pay, transaction, publicKey } = useMakePayment()


  const showToast = (title, description, params) => {
    toast(title, {
      className: `  shadow text-neutral-200 border-orange-500/10 bg-black/50 `,
      description: description,
      duration: params?.duration || 5000,
      position: params?.position || 'top-left',
      dismissible: true,
    });
  }

  useEffect(() => {

  }, [])



  const createSubscription = async (transactionDetails) => {
    try {
      const response = await axios.post('https://archangelbot.fun/api/subscribe', {
        walletAddress: transactionDetails.walletAddress,
        transactionSignature: transactionDetails.transactionSignature,
        duration: transactionDetails.duration // or 'monthly'
      }, {
        headers: {
          'Content-Type': 'application/json', // Ensure the server knows it's JSON
          'walletaddress': publicKey?.toBase58(), // Custom header if needed
        }
      });
      // Store download token securely
      localStorage.setItem('downloadToken', response.data.downloadToken);
      return response.data;
    } catch (error) {
      console.error('Subscription failed:', error);
      throw error;
    }
  };


  return (
    <div className="flex justify-center items-center   p-4 bg-gradient-to-tl from-black to-black/20 w-full rounded-2xl z-10">

      <div className="w-full max-w-md space-y-5">

        {
          !connected && !loading && <h1 className="text-white text-4xl text-center font-logo animate-pulse">Please connect your wallet first</h1>
        }
        {
          loading && <h1 className="text-white text-4xl text-center font-logo animate-pulse">Loading ...</h1>
        }

        {user?.whitelisted && !loading &&
          <div className='flex flex-cols font-light flex-col justify-center items-center gap-5 py-20'>
            {/* <p>your Subscription ends At : </p>
            <p className='text-2xl text-center text-neutral-400'>{convertTime(user.expiresAt)}</p>
            <Button
              onClick={startTrading}
              disabled={!connected}
              className="w-full hover:bg-yellow-500 bg-neutral-900 hover:text-black">
              Start Trading

            </Button> */}

            <div className=' grid grid-cols-1 gap-2 w-full'>
              <div className='bg-green-800/20 flex gap-2 px-5 py-4 rounded-full items-center w-full '>
                <FaCheckCircle className='text-green-500 text-2xl' />
                <p className=''> Thank you for your Support you are whitelisted for Bot Early Access and token Private Sale 🎉🎉🥳 </p>
              </div>
            </div>


            <div className='grid gap-2'>

              <p>whitelist plan :  {user.plan} </p>
              <p> payment amount : {user.payment}$</p>
            </div>


            <p className='text-center'>Please join our telegram channel and group and follow us for latest updates </p>
          </div>}

        {!user?.whitelisted && connected && !loading &&
          <div className='flex flex-col gap-5 w-full py-10'>
            <WhitelistPaymentSelector userData={user} solPrice={solPrice} publicKey={publicKey} pay={pay} transaction={transaction} />
          </div>
        }
        <div className='flex gap-5 items-center text-center justify-center'>
          <Link to={socials.tg} target='_blank'>
          <FaTelegram className='text-2xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
          </Link>
          <Link  to={socials.x} target='_blank'>
          <FaSquareXTwitter className='text-2xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhiteListsPayment;